module.exports = __webpack_public_path__ + "static/img/story06.84750dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/story/story06.jpg
// module id = MIYj
// module chunks = 1